// First-touch UTM capture. Marketing links like
// /?utm_source=tiktok&utm_medium=social&utm_campaign=august_2026 should be
// attributed to whichever visit first brought the user in — not overwritten
// by a later visit — so we stash them in localStorage on arrival and only
// ever read them once, at registration.

const UTM_KEY = 'mipisto_utm';
const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];

// Call once on app load. No-ops if there are no utm_* params, or if we
// already captured an earlier visit's params (first touch wins).
export function captureUtmParams() {
  try {
    if (typeof window === 'undefined') return;
    if (localStorage.getItem(UTM_KEY)) return;

    const params = new URLSearchParams(window.location.search);
    const found = {};
    UTM_PARAMS.forEach((key) => {
      const value = params.get(key);
      if (value) found[key] = value;
    });

    if (Object.keys(found).length > 0) {
      localStorage.setItem(UTM_KEY, JSON.stringify(found));
    }
  } catch (_) { /* localStorage may be unavailable (private mode, etc.) */ }
}

// Read back whatever was captured, to attach to the registration payload.
export function getStoredUtmParams() {
  try {
    const raw = localStorage.getItem(UTM_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (_) {
    return {};
  }
}

// Referral code capture — same first-touch-wins pattern as the UTM params
// above, for links like /?ref=ABC123DEF456 shared from Settings' "Invitá a
// un amigo" card. Kept separate from UTM_KEY since a referral is a specific
// person, not a marketing channel, and the two can coexist on the same URL.
const REF_KEY = 'mipisto_ref';

export function captureRefParam() {
  try {
    if (typeof window === 'undefined') return;
    if (localStorage.getItem(REF_KEY)) return;
    const ref = new URLSearchParams(window.location.search).get('ref');
    if (ref) localStorage.setItem(REF_KEY, ref);
  } catch (_) { /* localStorage may be unavailable (private mode, etc.) */ }
}

export function getStoredRef() {
  try {
    return localStorage.getItem(REF_KEY) || undefined;
  } catch (_) {
    return undefined;
  }
}

// Shared-goal invite links (/?goal_invite=CODE&ref=...). Unlike ref/UTM,
// the latest link wins — tapping a new invite should offer that goal. It's
// held until the user is signed in and onboarded, then App shows the join
// prompt and clears it.
const GOAL_INVITE_KEY = 'mipisto_goal_invite';

export function captureGoalInvite() {
  try {
    const code = new URLSearchParams(window.location.search).get('goal_invite');
    if (code) localStorage.setItem(GOAL_INVITE_KEY, code);
  } catch (_) { /* localStorage may be unavailable */ }
}

export function getPendingGoalInvite() {
  try { return localStorage.getItem(GOAL_INVITE_KEY) || null; } catch (_) { return null; }
}

export function clearPendingGoalInvite() {
  try { localStorage.removeItem(GOAL_INVITE_KEY); } catch (_) { /* ignore */ }
}
